<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px border-bottom-light2">

        Edit Package

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body padding-top-0px padding-bottom-0px">
        <!--<div class="row border-top border-bottom margin-top-5px bk-color-light" *ngIf="SelectedService">
          <div class="col-md-4  text-align-left">
            <div><label class=" font-weight-bold label-color-consultant">Service Name</label></div>
            <div><label>{{SelectedService.Name}}</label></div>
          </div>
          <div class="col-md-4  text-align-left">
            <div><label class="label-color-consultant  font-weight-bold">Category</label></div>
            <div><label>{{SelectedService.ServiceCategory}}</label></div>
          </div>
          <div class="col-md-4 text-align-left">
            <div><label class=" font-weight-bold label-color-consultant">Base Price</label></div>
            <div><label>{{SelectedService.BasePrice}}</label></div>
          </div>
        </div>-->
       

        <!--<ul class="nav nav-tabs nav-tab-service margin-top-13px" id="tabContent">
          <li class="active margin-right-30px" ><a class="nav-item2 active" href="#details" data-toggle="tab">List</a></li>
          <li><a class="nav-item2" href="#access-security" data-toggle="tab">Add/Edit</a></li>
        
        </ul>-->



          
        <div class="row">





          <div class="col-md-8" >

            <div class="row">
              <div class="col-md-12 padding-left-2px padding-right-0px">
                <div class="card">

                  <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-top-0px padding-bottom-0px">
                    <div class="row border-top border-bottom bk-color-light margin-left-zero">
                      <div class="col-md-4  text-align-center padding-right-0px padding-left-0px border-right-1px">
                        <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Package Name</h4></div>
                        <div class="margin-bottom-10px"><h4 class="margin-bottom-0px">HBEAG</h4></div>
                      </div>
                      <div class="col-md-4  text-align-center padding-right-0px padding-left-0px border-right-1px">
                        <div class="margin-top-10"><h4 class="font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Branch</h4></div>
                        <div class="margin-bottom-10px"><h4 class="margin-bottom-0px">Kalyan Nagar</h4></div>
                      </div>
                      <div class="col-md-4 text-align-center padding-right-0px padding-left-0px border-right-1px">
                        <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Package Cost</h4></div>
                        <div class="margin-bottom-10px"><h4 class="margin-bottom-0px">2350</h4></div>
                      </div>
                    </div>

                    <!--<div class="row">
                      <div class="col-md-4">
                        <div class="row">
                          <label>Package Name</label>
                        </div>
                        <div class="row">
                          <label>HBEAG</label>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="row">
                          <label>Branch</label>
                        </div>
                        <div class="row">
                          <label>Kalyan Nagar</label>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="row">
                          <label>Package Cost</label>
                        </div>
                        <div class="row">
                          <label>2350</label>
                        </div>
                      </div>

                    </div>-->
                    <div class="row">
                      <div class="col-md-12 padding-right-0px">
                        <div class="table-component">
                          <div class="table-responsive">


                            <table class="table table-striped margin-left-zero width-100">

                              <thead class="">
                                <tr>

                                  <th class="min-width-0px"></th>
                                  <th>Service</th>

                                  <th class="th-width-111px">Branch Price</th>
                                  <th>Custom Price</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody class="table-body">

                                <tr>
                                  <td class="td-padding">

                                    <input type="checkbox"
                                           
                                           [(ngModel)]="IsSelected" />
                                    <i class="input-helper"></i>

                                  </td>
                                  <td>HBEAG</td>
                                  <td class="text-align-right">900</td>

                                  <td class="td-padding ">

                                    <input type="number" class="form-control"
                                           min="1" max="10" />

                                  </td>

                                  <td class="text-align-right">
                                    <button type="submit" (click)="onSubmit(l)" class="button-service-save font-size-16px color-secondary nav-link-hand" title="Save" *ngIf="IsSelected"><i class="far fa-save"></i></button>
                                    <button (click)="OnDelete(l)" class="button-service-save font-size-16px color-Rejected  nav-link-hand" title="Delete" *ngIf="IsSelected "><i class="far fa-trash-alt"></i></button>

                                  </td>



                                </tr>

                              </tbody>

                            </table>

                          </div>
                        </div>
                      </div>
                    </div>
                   


                  </div>
                  <!--<div class=" card-footer text-align-center">
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto" (click)="activeModal.close('Close click')">Cancel</button>
            <button type="submit" *ngIf='!isRequesting' (click)="gotoservice()" class="btn actions-btn-prime margin-right-auto">Save</button>
          </div>-->
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4  padding-right-0px border-right">
            <div class="card">
              <div class="card-header wh-header header3 padding-left-14px font-size-16px padding-bottom-4px bk-color-light">
                Branch Services

              </div>
              <div class="card-body padding-top-0px margin-left-zero padding-left-0px padding-right-0px bk-color-light padding-bottom-0px">
                <div class="row  padding-top-5 padding-bottom-5px margin-right-0px">
                  <div class="col-md-10 padding-right-0px margin-left-14px">
                    <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
                  </div>


                </div>
                <div class="chatsd product-chart-wrapper product-chat-width-92 agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                  <div class="table-component actor-table">

                    <div class="table-responsive padding-right-11px">


                      <table class="table table-striped table2">
                        <tbody>
                          <tr *ngFor="let l of CurrentServicesByCategoryCodeController">
                            <td class="td-padding-2px">

                              <div class="row margin-left-zero margin-right border4 margin-top-3px">
                                <div class="col-md-2  margin-tb-auto padding-lr-2px">
                                  <button type="button"
                                          
                                          class="btn  btn-sm plus-button " id="FileUpload"
                                          name="upload">
                                    <i class="fas fa-plus font-size-11p"></i>
                                  </button>
                                </div>
                                <div class="col-md-10 margin-tb-auto padding-left-11px">
                                  <label class="margin-bottom-0px color3">{{l.ServiceName}}</label>
                                  
                                </div>
                              </div>


                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
          

         
        
        

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
      </div>
  </div>
</div>
  </div>
